export default __webpack_public_path__ + "static/media/Monger-HUD-Diagnostic Widget.59e4e3d8.jpg";